import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  details: null,
  fetchingDropdown: false,
  reportUploadInProgress: false,
  downloadInProgress: false,
  orderStatusUpdate: false,
  dropdowns: {},
};

const orderDetailsSlice = createSlice({
  name: "labOrderDetails",
  initialState,
  reducers: {
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.details = null;
      state.fetchingDropdown = false;
      state.reportUploadInProgress = false;
      state.downloadInProgress = false;
      state.orderStatusUpdate = false;
      state.dropdowns = {};
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchOrderDetails(state, action) {
      state.loading = true;
      state.details = null;
    },
    fetchOrderDetailsSuccess(state, action) {
      state.details = action.payload.data.document;
      state.loading = false;
    },
    fetchOrderDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
    downloadFile(state, action) {
      state.downloadInProgress = true;
    },
    downloadFileSuccess(state, action) {
      state.downloadInProgress = false;
    },
    downloadFileFailure(state, action) {
      state.downloadInProgress = false;
    },
    updateOrderStatus(state, action) {
      state.orderStatusUpdate = true;
    },
    updateOrderStatusSuccess(state, action) {
      state.statusUnderUpdate = false;
      state.details = action.payload.data.document;
    },
    updateOrderStatusFailure(state, action) {
      state.statusUnderUpdate = false;
      state.error = action.payload.error;
    },
    uploadReport(state, action) {
      state.reportUploadInProgress = true;
    },
    uploadReportSuccess(state, action) {
      state.details = action.payload.data.document;
      state.reportUploadInProgress = false;
    },
    uploadReportFailure(state, action) {
      state.reportUploadInProgress = false;
      state.error = action.payload.message;
    },
    updateSampleReceived(state, action) {
      state.loading = true;
    },
    updateSampleReceivedSuccess(state, action) {
      state.details = action.payload.data.document;
      state.loading = false;
    },
    updateSampleReceivedFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    moveToUnderTesting(state, action) {
      state.loading = true;
    },
    moveToUnderTestingSuccess(state, action) {
      state.loading = false;
    },
    moveToUnderTestingFalse(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = orderDetailsSlice;
